module.exports = __webpack_public_path__ + "static/media/edit-2.248d5acc.svg";